import { useEffect } from "react";
import {
  getUrlParams,
  localStorage,
  checkEmptyArray,
} from "../../../services";
import {
  PageRoute,
  LocalStorageKey,
  QueryParam
} from "../../../models";

export const useInitializeSearchBar = (
  recentSearches,
  setRecentSearches,
  addRootScrollBar,
  setRecentQueryParams,
  history,
  isFocus,
  setIsFocus,
  searchText,
  setSearchText,
  getSuggestions
) => {

  const parseRecentSearch = () => {
    if (!checkEmptyArray(recentSearches)) {
      const localRecentSearches = localStorage.getItem(LocalStorageKey.recentSearches);
      if (localRecentSearches) {
        setRecentSearches(localRecentSearches);
      }
    }

    if (checkEmptyArray(recentSearches)) {
      setRecentQueryParams(recentSearches[0]);
    }
  };

  useEffect(() => {
    // Subscribe to history changes inside useEffect
    const unlistenHistory = history.listen(location => {
      if (isFocus) {
        setIsFocus(false);
      }
      const searchParams = getUrlParams(location.search, QueryParam.searchQuery);
      if (searchParams && (searchParams.searchText || searchParams.text)) {
        setSearchText(searchParams.searchText || searchParams.text);
      } else if (searchText != "" && !location.pathname.includes(PageRoute.search)) {
        setSearchText("");
      }
      if (location.pathname.includes(PageRoute.search)) {
        parseRecentSearch();
      }
    });

    parseRecentSearch();
    getSuggestions("");

    return () => {
      unlistenHistory();
      addRootScrollBar();
    };
  }, []);

}


// WEBPACK FOOTER //
// ./src/containers/HomePage/hooks/useInitializeSearchBar.ts